module.exports = __webpack_public_path__ + "static/1-759c1215e5e7a20074096f15d81b7238.png";